import React from "react";

import { createRoot } from "react-dom/client";

import "./index.css";
import { Provider } from "react-redux";
import { QueryClientProvider, QueryCache, QueryClient } from "react-query";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@se/icons/css/styles.css";
import { store } from "./store";

const queryCache = new QueryCache();
const queryClient = new QueryClient(queryCache);

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
